import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const UserForm = ({ userId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [userName, setUserName] = useState('');
     const [userCode, setUserCode] = useState('');
     const [role, setRole] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.user_name) {
               setUserName(initialData.user_name);
          }
          if (initialData && initialData.role) {
               setRole(initialData.role);
          }
          if (initialData && initialData.user_code) {
               setUserCode(initialData.user_code);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!userName.trim()) {
               setError('User name is required');
               return;
          }

          if (!userCode.trim()) {
               setError('User code is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               const token =
                    sessionStorage.getItem('token') || localStorage.getItem('authToken');

               if (!token) {
                    console.error('Authentication token not found. Please login again.');
                    setError('Authentication token missing. Please log in again.');
                    setLoading(false);
                    return;
               }

               let url = '';
               let method = 'POST';
               let body = { user_name: userName, role, user_code: userCode };

               if (userId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateRadiologyUser/${userId}`;
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createUser`;
               }

               const response = await fetch(url, {
                    method,
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`, // ✅ Correct placement
                    },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(userId ? 'USER updated successfully' : 'USER created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/users');
               } else {
                    setError(data.message || `Failed to ${userId ? 'update' : 'create'} USER`);
               }
          } catch (err) {
               console.error('Error:', err);
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };


     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               {/* <h2 className="section-title mb-5">{userId ? 'Edit USER' : 'Add USER'}</h2> */}
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="userName"
                              placeholder=" "
                              autoComplete="off"
                              value={userName}
                              onChange={(e) => setUserName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="userName">USER Name</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              id="userCode"
                              placeholder=" "
                              autoComplete="off"
                              value={userCode}
                              onChange={(e) => setUserCode(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="userCode">USER Code</label>
                    </div>
                    <div className="form-floating">
                         <select
                              className="form-select"
                              id="userRole"
                              value={role}
                              onChange={(e) => setRole(e.target.value)}
                              disabled={loading}
                         >
                              <option value="">Select Role</option>
                              <option value="HOD_DOCTORS">HOD_DOCTORS</option>
                              <option value="HOD_CONTRACTUAL">HOD_CONTRACTUAL</option>
                              <option value="HOD_POOJARI">HOD_POOJARI</option>
                              <option value="BRANCH_MANAGER">BRANCH_MANAGER</option>
                              <option value="HR">HR</option>
                              <option value="EMPLOYEE">EMPLOYEE</option>
                              <option value="REPORTING_MANAGER">REPORTING MANAGER</option>
                              <option value="HR_RADIOLOGY">HR Radiology</option>
                              <option value="HR_INTERNAL">HR Internal</option>
                              <option value="USER_RADIOLOGY">USER RADIOLOGY</option>
                              <option value="USER_INTERNAL">USER INTERNAL</option>
                              <option value="SUPER_ADMIN">SUPER ADMIN</option>
                         </select>
                         <label htmlFor="userRole">Role</label>
                    </div>
               </div>
               {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
               <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: '15px' }}
                    disabled={loading}
               >
                    {loading ? 'Saving...' : 'Save'}
               </button>
          </form >
     );
};

export default UserForm;
